import { CivilCase } from './../../../civil/civil-case';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-creditor-section',
  templateUrl: './creditor-section.component.html',
  styleUrls: ['./../civil-case-view.component.less']
})

// Template component of Judgment Abstracts to present the
// Creditor  Debtor sections.
// This template is used 8 times in the JA template.
export class CreditorSectionComponent implements OnInit {

  @Input() civilCase: CivilCase;
  @Input() abstractDetailList: any[] = [];
  @Input() abstract: any;
  @Input() jaIndex: string;
  @Input() detailName: string;
  @Input() detailType: string;
  @Input() vCodeLabelDigit: string;
  @Input() showDebtorSection: boolean;
  @Input() debtorDetailName: string;

  constructor() { }

  ngOnInit() {
  }
  getAbstractDetailList(): any[] {
    return this.abstractDetailList;
  }
  getJaIndex(): string {
    return this.jaIndex;
  }
  getDetailName(): string {
    return this.detailName;
  }
  getDetailType(): string {
    return this.detailType;
  }
  getVCodeLabelDigit(): string {
    return this.vCodeLabelDigit;
  }
  getShowDebtorSection(): boolean {
    return this.showDebtorSection;
  }
  getDebtorDetailName(): string {
    return this.debtorDetailName;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/judgments/creditor-section.component.ts